import React from 'react'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import { ConfigProvider } from 'antd'
import { useTranslation } from 'react-i18next'

import './i18n'

import { Router } from './navigation/Router'
import { persistor, store } from './core/store'
import { ANTD_NEW_THEME } from './style/antd/antdTheme'

function App() {
  const { t } = useTranslation()

  return (
    <React.StrictMode>
      <ConfigProvider prefixCls="retino-bridge" theme={ANTD_NEW_THEME}>
        <Provider store={store}>
          <PersistGate persistor={persistor} loading={<p>{t('loading')}</p>}>
            <Router />
          </PersistGate>
        </Provider>
      </ConfigProvider>
    </React.StrictMode>
  )
}

export default App
